import { createContext, useContext } from 'react';

export const ResourceSchemeContext = createContext<Record<string, string>>({});

export const ResourceSchemeProvider = ResourceSchemeContext.Provider;

export function useResourceScheme(fileId: string): string {
  const map = useContext(ResourceSchemeContext);
  return map[fileId] ?? 'xm';
}

export const SharableLinkContext = createContext<Record<string, string>>({});

export const SharableLinkProvider = SharableLinkContext.Provider;

export function useSharableLink(fileId: string): string | undefined {
  const map = useContext(SharableLinkContext);
  return map[fileId];
}
